import OrderService from '../services/order.service'

export const orderModule = {
  namespaced: true,

  state: {
    orders: [],
    orderDetail: null,
    order: null,
    criterias: null,
    invalidData: null
  },

  actions: {
    async list ({ commit }) {
      return OrderService.list().then(
        response => {
          const orders = response.data
          commit('listSuccess', orders)
          return Promise.resolve(orders)
        },
        error => {
          commit('listFailure')
          return Promise.reject(error)
        }
      )
    },

    async search ({ commit }, criterias) {
      return OrderService.search(criterias).then(
        response => {
          const orders = response.data.orders
          commit('searchSuccess', orders)
          return Promise.resolve(orders)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async getDetail ({ commit }, criterias) {
      return OrderService.detail(criterias).then(
        response => {
          const orderDetail = response.data.orderDetail
          commit('detailSuccess', orderDetail)
          return Promise.resolve(orderDetail)
        },
        error => {
          commit('detailFailure')
          return Promise.reject(error.response)
        }
      )
    },

    async remindPin ({ commit }, criterias) {
      return OrderService.remindPin(criterias).then(
        response => {
          const responseData = response.data
          return Promise.resolve(responseData)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async resetDetail ({ commit }) {
      commit('detailReset')
    },

    async setOrder ({ commit }, order) {
      commit('orderSuccess', order)
    },

    async setCriterias ({ commit }, criterias) {
      commit('setCriterias', criterias)
    },

    async resetCriterias ({ commit }) {
      commit('resetCriterias')
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }

  },

  mutations: {
    listSuccess (state, orders) {
      state.orders = orders
    },
    listFailure (state) {
      state.orders = []
    },
    listReset (state) {
      state.orders = []
    },
    searchSuccess (state, orders) {
      state.orders = orders
    },
    searchFailure (state) {
      state.orders = []
    },
    detailSuccess (state, orderDetail) {
      state.orderDetail = orderDetail
    },
    detailFailure (state) {
      state.orderDetail = null
    },
    detailReset (state) {
      state.orderDetail = null
    },
    orderSuccess (state, order) {
      state.order = order
    },
    setCriterias (state, criterias) {
      state.criterias = criterias
    },
    resetCriterias (state) {
      state.criterias = null
    },
    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
